import { Component } from '@angular/core';
import { IonicPage, Events, NavController } from 'ionic-angular';
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { DeveloperProvider } from "../../providers/developers";
import { ToastProvider } from "../../providers/toast";
import { CustomErrorHandler } from "@questrade/flx-commons";

@IonicPage({
  name: 'sandbox'
})
@Component({
  selector: 'page-sandbox',
  templateUrl: 'sandbox.html',
})

export class SandboxPage {
  constructor(
    private iab: InAppBrowser,
    private devProvider: DeveloperProvider,
    private events: Events,
    private navCtrl: NavController,
    private toast: ToastProvider,
    private customErrorHandler: CustomErrorHandler) {
    this.events.publish('menu:changed', true, 'SandBox');
  }

  // TODO: Delete this method after the testing is finished
  goToOnlinePortal() {
    this.devProvider.goToOnlinePortal()
      .subscribe(
        data => {
          let redirection_url = data['redirection_url'];
          const browser = this.iab.create(redirection_url);
          browser.show();
        },
        error => {
          console.log(error);
        });
  }
}



// WEBPACK FOOTER //
// ./src/pages/sandbox/sandbox.ts